import {SettingParamTypes, FlowNodeData, FlowNodeTypes} from "@/types/node";
import {Node} from "@xyflow/react";

export const stepNodeBlueprint: Partial<Node<FlowNodeData>> = {
  type: FlowNodeTypes.STEP,
  position: {x: 0, y: 0},
  measured: {height: 115, width: 340},
  data: {
    type: FlowNodeTypes.STEP,
    settingsTitle: "New Step",
    nodeTitle: "New Step",
    description: "This is the step node",
    onChange: () => {
      console.log("Start node changed");
    },
    isEmpty: true,
    settings: [
      {
        title: "General",
        params: [
          {
            label: "Step Name",
            placeholder: "Enter Step Name",
            type: SettingParamTypes.INPUT,
            key: "name",
            value: "",
          },
          {
            label: "Instructions",
            placeholder:
              "Add instructions on how the AI Assistant should behave during this step.",
            type: SettingParamTypes.PROMPT,
            key: "instructions",
            value: "",
          },
          {
            label: "Actions",
            type: SettingParamTypes.ACTIONS,
            key: "actions",
            value: [],
          },
        ],
      },
    ],
  },
};
